import React from "react";

export default function NotFoundPage() {
  return (
    <>
      <title>Az oldal nem található – Solarya</title>
      <meta name="robots" content="noindex, nofollow" />
      <div style={{padding: '2rem'}}>
        <h1>Az oldal nem található</h1>
        <p>Térj vissza a <a href="/kategoriak">főoldalra / kategóriákhoz</a>.</p>
      </div>
    </>
  );
}
